import { TeamsRankingQuery } from "../types";
import { isValidTeamsRanking } from "./typeguards";
import { ErrorName, WidgetError } from "../../../utils/errors";
import {
  IMotorsportsTeamsStandings,
  ITopMotorsportsTeamsRow,
  ITopMotorsportsTeamsTable,
} from "@sky-it-livedata/livedata-sports-design-system";
import { intcmpMap } from '../../../utils/intcmp';

import {
  CreateTeamRankingWidgetInputSchema,
  TeamRankingWidget,
  TeamRankingTeam,
} from "cdk/graphql";

const FALLBACK_LABEL = "-";


const getTeamNameTeamInfoTotalPoints = (row: TeamRankingTeam): string =>
  row.teamName ?? FALLBACK_LABEL; 

const transformRow = (row: TeamRankingTeam): ITopMotorsportsTeamsRow => {
  const {
    pos: position,
    pts: points,
    customTeamPageUrl: teamUrl,
  } = row as TeamRankingTeam;

  return {
    position: position as string,
    points: points as string,
    teamName: getTeamNameTeamInfoTotalPoints(row),
    teamUrl: teamUrl as string,
  };
};

const transformRows = (
  rowsData: TeamRankingWidget
): ITopMotorsportsTeamsTable => {
  const rows = rowsData!.items!.map((item) => transformRow(item!));

  return {
    rows: rows,
    trackingData: intcmpMap.teamsRanking,
  };
};

export default (obj: TeamsRankingQuery): IMotorsportsTeamsStandings => {
  if (isValidTeamsRanking(obj)) {
    const teamRankingWidget = obj.data.getTeamRankingWidget;

    CreateTeamRankingWidgetInputSchema().parse(teamRankingWidget, { reportInput: true });

    const { competitionLabel } = teamRankingWidget;

    return {
      competitionName: competitionLabel!,
      standingsList: [ transformRows(teamRankingWidget) ],
    };
  } else {
    throw new WidgetError<ErrorName>({
      name: "NO_VALID_DATA",
      message: "Invalid transformer input, Error in TeamsRankingQuery object",
      data: obj,
    });
  }
};
